__turbopack_context__.v({
  "accordionHeader": "ZQeioG_accordionHeader",
  "descriptionAnswerWrapper": "ZQeioG_descriptionAnswerWrapper",
  "expand_btnMDFlow": "ZQeioG_expand_btnMDFlow",
  "expand_btnQ": "ZQeioG_expand_btnQ",
  "focusReadMoreLabel": "ZQeioG_focusReadMoreLabel",
  "readMoreLabel": "ZQeioG_readMoreLabel",
  "readMoreLabelMDFlow": "ZQeioG_readMoreLabelMDFlow",
});
